import { useEffect, useState, useMemo } from "react";
import { api } from "../lib/api";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import PostCard from "../components/PostCard";
import useReveal from "../hooks/useReveal";

const CATEGORIAS = [
  "Todos",
  "Reflexión",
  "Rutina",
  "Personas",
  "Tiempo",
  "Memoria",
  "Lecturas",
  "Ciudad",
  "Trabajo",
  "Naturaleza",
  "Notas rápidas",
];

const PAGE_SIZE = 6;

export default function Escritos() {
  const [posts, setPosts] = useState([]);
  const [activeTag, setActiveTag] = useState("Todos");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);

  useReveal();

  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data.items || []));
  }, []);

  useEffect(() => {
    setPage(1);
  }, [activeTag, query]);

  const filtered = useMemo(() => {
    return posts.filter((p) => {
      const catOk = activeTag === "Todos" || p.categoria === activeTag;
      const qOk =
        !query.trim() ||
        p.titulo.toLowerCase().includes(query.trim().toLowerCase());
      return catOk && qOk;
    });
  }, [posts, activeTag, query]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <>
      <Nav />
      <header className="page-header" data-testid="page-header">
        <div className="container">
          <h1 className="reveal">
            Archivo <em>completo</em>
          </h1>
          <p className="reveal d1">
            Todas las entradas publicadas en este cuaderno. Filtra por asunto o
            busca por título.
          </p>
        </div>
      </header>

      <section className="section" data-testid="archive-section">
        <div className="container">
          <div className="archive-controls reveal">
            <div className="tags-cloud">
              {CATEGORIAS.map((t) => (
                <button
                  key={t}
                  className={`tag-btn ${activeTag === t ? "active" : ""}`}
                  onClick={() => setActiveTag(t)}
                  data-testid={`archive-tag-${t}`}
                >
                  {t}
                </button>
              ))}
            </div>
            <input
              type="search"
              className="search-input"
              placeholder="Buscar por título…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              data-testid="archive-search"
            />
          </div>

          {pageItems.length === 0 ? (
            <div style={{ padding: 80, textAlign: "center", color: "var(--ink-3)" }}>
              No hemos encontrado entradas con esos criterios.
            </div>
          ) : (
            <div className="posts-grid">
              {pageItems.map((p, i) => (
                <PostCard key={p.slug} post={p} index={i} />
              ))}
            </div>
          )}

          {totalPages > 1 && (
            <div className="pagination" data-testid="pagination">
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
                data-testid="pagination-prev"
              >
                ← Anterior
              </button>
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i}
                  className={page === i + 1 ? "active" : ""}
                  onClick={() => setPage(i + 1)}
                  data-testid={`pagination-page-${i + 1}`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
                data-testid="pagination-next"
              >
                Siguiente →
              </button>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
}
